var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExclamationIcon = function SvgExclamationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.502a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-12.429c.473 0 .857.384.857.858v3.714a.857.857 0 1 1-1.714 0V6.93c0-.474.384-.858.857-.858Zm1.143 7.715a1.143 1.143 0 1 1-2.286 0 1.143 1.143 0 0 1 2.286 0Z",
    fill: "#B84040"
  })));
};
export default SvgExclamationIcon;